/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/ActionsAction/Edit/Content/Name",
  onChange,
  isInvalid
  
}) {
let editNameValueData = fromData.useDataValue({ viewPath,
context: 'edit',
path: 'name',
})
let editNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit',
path: 'name',
validate: fromValidate.textInput,
required: true,
})
let editNameChangeData = fromData.useDataChange({ viewPath,
context: 'edit',
path: 'name',
})
  return (<React.Fragment
>
<div
  data-testid="Name.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit.name"
 value={editNameValueData}
 onChange={editNameChangeData}
 validate="/Data/validate.js textInput"
 required={true}
 invalid={!editNameIsValidData}
 marginTop={0}
 type="text"
 placeholder="Procedure name"
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}